import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import API from '../utils/api';

export default function DonationSuccess() {
  const { t } = useTranslation();
  const [params] = useSearchParams();
  const txnid = params.get('txnid');
  const [donation, setDonation] = useState(null);

  useEffect(() => {
    if (txnid) {
      // Razorpay's handler already POSTed the payment fields to /donations/verify
      // client-side before navigating here — this just re-fetches the confirmed status
      API.get(`/donations/check/${txnid}`).then(r => setDonation(r.data)).catch(() => {});
    }
  }, [txnid]);

  return (
    <div style={{ textAlign: 'center', padding: '80px 20px', minHeight: '60vh' }}>
      <div style={{ fontSize: '5rem', marginBottom: 20 }}>🙏</div>
      <h1 style={{ fontSize: '2.2rem', fontWeight: 700, color: 'var(--green)', marginBottom: 12 }}>{t('donationSuccess.title')}</h1>
      <p style={{ fontSize: '1.1rem', color: '#555', marginBottom: 8 }}>{t('donationSuccess.thankYou')}</p>
      <p style={{ fontFamily: 'Noto Serif Devanagari, serif', fontSize: '1.2rem', color: 'var(--saffron)', marginBottom: 24 }}>
        गो-सेवा करने वाले को दिव्य आशीर्वाद प्राप्त होते हैं 🐂
      </p>
      {donation && (
        <div style={{ background: 'var(--green-light)', borderRadius: 12, padding: '16px 28px', display: 'inline-block', marginBottom: 24 }}>
          <div style={{ fontSize: '1.5rem', fontWeight: 700, color: 'var(--green)' }}>₹{donation.amount?.toLocaleString('en-IN')}</div>
          {donation.receiptNumber && <div style={{ color: '#555', fontSize: '0.9rem', marginTop: 4 }}>{t('donationSuccess.receipt', { num: donation.receiptNumber })}</div>}
        </div>
      )}
      <p style={{ color: '#888', fontSize: '0.9rem', marginBottom: 32 }}>{t('donationSuccess.emailNote')}</p>
      <div style={{ display: 'flex', gap: 16, justifyContent: 'center', flexWrap: 'wrap' }}>
        <Link to="/" className="btn btn-primary">{t('common.backToHome')}</Link>
        {donation?.receiptNumber && txnid && (
          <Link to={`/donation/receipt/${txnid}`} target="_blank" rel="noopener noreferrer" className="btn btn-green">{t('donationSuccess.printReceipt')}</Link>
        )}
        <Link to="/my-donations" className="btn btn-outline">{t('common.myDonations')}</Link>
      </div>
    </div>
  );
}
